import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class TeamsTeamCheckInRoute extends Route {
  @service store;
  @service router;
  @service betaToggle;
  async setupController(controller, model) {
    super.setupController(controller, model);
    Promise.all([
      model.questions,
      model.lls,
      model.tfos,
      model.uncertainties,
      model.wfas,
      model.bookmarks,
      this.store.findAll('initiative', { backgroundReload: true }),
    ]).then(() => {
      return;
    });
  }

  async beforeModel() {
    if (!this.betaToggle.showCheckin)
      return this.router.transitionTo('operations.teams.team.home');
    await this.store.findAll('person');
  }

  model() {
    return this.modelFor('operations.teams.team');
  }
}
